import { useElementSize, useMediaQuery } from "@mantine/hooks";

export default function useStickyLabFlowSheetTable(columnWidth: number) {
  const isLargeScreen = useMediaQuery(`(min-width: 1280px)`) ?? true;
  const { ref: firstHeaderRowRef, height: firstHeaderRowHeight } = useElementSize();

  const baseCellStyle = {
    borderRight: "1px solid var(--mantine-color-cream-4)",
    borderBottom: "1px solid var(--mantine-color-cream-4)",
    width: columnWidth,
  };

  const stickyColumnStyle = isLargeScreen
    ? {
        ...baseCellStyle,
        position: "sticky" as const,
        left: 0,
        zIndex: 1,
        backgroundColor: "var(--mantine-color-white)",
      }
    : baseCellStyle;

  const stickyFirstRowStyle = isLargeScreen
    ? {
        ...baseCellStyle,
        position: "sticky" as const,
        top: 0,
        zIndex: 2,
        backgroundColor: "var(--mantine-color-gray-0)",
      }
    : { ...baseCellStyle, backgroundColor: "var(--mantine-color-gray-0)" };

  const stickySecondRowStyle = isLargeScreen
    ? {
        ...baseCellStyle,
        position: "sticky" as const,
        top: firstHeaderRowHeight,
        zIndex: 2,
        backgroundColor: "var(--mantine-color-white)",
      }
    : baseCellStyle;

  const stickyCornerFirstRowStyle = isLargeScreen
    ? { ...stickyColumnStyle, ...stickyFirstRowStyle, zIndex: 3 }
    : { ...baseCellStyle, backgroundColor: "var(--mantine-color-gray-0)" };

  const stickyCornerSecondRowStyle = isLargeScreen
    ? { ...stickyColumnStyle, ...stickySecondRowStyle, zIndex: 3 }
    : baseCellStyle;

  return {
    firstHeaderRowRef,
    baseCellStyle,
    stickyColumnStyle,
    stickyFirstRowStyle,
    stickySecondRowStyle,
    stickyCornerFirstRowStyle,
    stickyCornerSecondRowStyle,
  };
}
